export default __webpack_public_path__ + "static/media/logo-pano.0e4ee40d.svg";